import { Form as unform } from "@unform/web";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  height: fit-content;
  padding: 32px;
  width: 100%;

  ${media.greaterThan("medium")`
    padding: 48px;
  `}
`;

export const Row = styled.div`
  display: grid;
  grid-gap: 24px;
`;

export const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;

  h1 {
    color: ${({ theme }) => theme.colors.neutral.neutral8};
    font-family: ${({ theme }) => theme.font.fontFamily};
    ${({ theme }) => theme.font.all.xl};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    text-align: center;
    width: 130px;
  }

  p {
    color: ${({ theme }) => theme.colors.neutral.black};
    font-family: ${({ theme }) => theme.font.fontFamily};
    ${({ theme }) => theme.font.all.x};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    text-align: center;
    width: 200px;
  }

  ${media.greaterThan("medium")`
    gap: 40px;
  `}
`;

export const Form = styled(unform)`
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
